import { render, staticRenderFns } from "./PartnerUrls.vue?vue&type=template&id=584044e0&"
import script from "./PartnerUrls.vue?vue&type=script&lang=js&"
export * from "./PartnerUrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports